import { Fragment } from 'react';

import {
  Button,
  TruncateText,
  typographyVariants,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Breadcrumb = {
  folderId: string;
  name: string;
};

type Props = {
  items: Breadcrumb[];
  onFolderChange: (id: string) => void;
};

const FileSystemBreadcrumbs = ({ items, onFolderChange }: Props) => {
  return (
    <div className="flex flex-wrap items-center justify-start gap-0">
      {items.map((item, index) => {
        const last = index === items.length - 1;

        return (
          <Fragment key={item.folderId}>
            <Button
              variant={'text'}
              className={cn('max-w-60 uppercase hover:bg-transparent', {
                'disabled:pointer-events-auto disabled:cursor-auto disabled:text-text-primary':
                  last,
              })}
              onClick={last ? undefined : () => onFolderChange(item.folderId)}
              disabled={last}
            >
              <TruncateText tooltipClassName="uppercase">
                {item.name}
              </TruncateText>
            </Button>

            {!last && (
              <p
                className={typographyVariants({
                  variant: 'h5',
                })}
              >
                /
              </p>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export { FileSystemBreadcrumbs };
